<div class="bg-white newheader">
    <div class="container d-flex align-items-center justify-content-end">
        <!-- Uncomment below if you prefer to use an image logo -->
        <!-- <a href="index.html" class="logo me-auto me-lg-0"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>-->
        <nav id="navbar" class="navbar order-last order-lg-0">
            <ul>
                <li>
                    <a routerLink="/academies-profile" [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{exact:true}" class="nav-link scrollto">INFO
                    </a>
                </li>
                <li>
                    <a routerLink="/academies-profile/highlights" [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{exact:true}" class="nav-link scrollto">WOW FACTOR / ACHIEVEMENTS
                    </a>
                </li>
                <li>
                    <a routerLink="/academies-profile/top-players" [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{exact:true}" class="nav-link scrollto ">TOP PLAYERS
                    </a>
                </li>
                <li>
                    <a routerLink="/academies-profile/courts" [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{exact:true}" class="nav-link scrollto">COURTS
                    </a>
                </li>
                <li>
                    <a routerLink="/academies-profile/branches" [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{exact:true}" class="nav-link scrollto">BRANCHES
                    </a>
                </li>
                <li>
                    <a routerLink="/academies-profile/coaches" [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{exact:true}">COACHES
                    </a>
                </li>
                <li>
                    <a routerLink="/academies-profile/our-tournaments" [routerLinkActive]="'active'"
                        [routerLinkActiveOptions]="{exact:true}" class="nav-link scrollto"
                        [routerLinkActive]="'active' ">OUR TOURNAMENTS
                    </a>
                </li>
                <!-- <li><a href="membership.html" class="nav-link scrollto">Memberships </a></li> -->
            </ul>
            <i class="bi bi-list mobile-nav-toggle"></i>
        </nav><!-- .navbar -->
        <!-- <a href="#about" class="get-started-btn scrollto">Get Started</a> -->
    </div>
</div>